import styled from 'styled-components';

const Disclaimer = styled.div`
`;

export default Disclaimer;